import { render, staticRenderFns } from "./ChangeNotice.vue?vue&type=template&id=1aed915e"
import script from "./ChangeNotice.vue?vue&type=script&lang=js"
export * from "./ChangeNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports